import React from "react";
import RegistrationCard from "../RegistrationCard";
import IDForm from "./IDForm";

const IDPage = ({ currentRegistration, onSubmit }) => {
  const { idType, idNumber } = currentRegistration;
  let { dateOfBirth, idTypeOther } = currentRegistration;

  idTypeOther = idTypeOther || null;
  dateOfBirth = dateOfBirth || null;

  return (
    <RegistrationCard
      title="Enter your date of birth and ID information"
      subtitle="Your ID will be verified at the counter, and is required for using the range."
      positiveActionLabel="Save & Continue"
    >
      <IDForm
        onSubmit={onSubmit}
        initialValues={{ idType, idTypeOther, idNumber, dateOfBirth }}
      />
    </RegistrationCard>
  );
};

IDPage.propTypes = {};
IDPage.defaultProps = {};

export default IDPage;



// WEBPACK FOOTER //
// ./src/registration/components/ID/IDPage.jsx